class AiUsageBreakdownRow {
    constructor(
        public label: string = "",
        public organizationId?: string,
        public organizationName?: string,
        public sourceId?: string,
        public sourceName?: string,
        public sourceType?: string,
        public aiConfigurationKind?: string,
        public aiConfigurationId?: string,
        public aiConfigurationName?: string,
        public aiExtractorId?: string,
        public aiExtractorName?: string,
        public aiExtractorType?: string,
        public model?: string,
        public openAiServiceTier?: string,
        public requestCount: number = 0,
        public apiCallCount: number = 0,
        public webSearchCallCount: number = 0,
        public inputTokens: number = 0,
        public inputCachedTokens: number = 0,
        public outputTokens: number = 0,
        public totalTokens: number = 0,
        public executionTimeMs: number = 0,
        public price: number = 0
    ) {
        //
    }

    public static fromPOJO(data: any) {
        return new AiUsageBreakdownRow(
            data?.label ?? "",
            data?.organizationId,
            data?.organizationName,
            data?.sourceId,
            data?.sourceName,
            data?.sourceType,
            data?.aiConfigurationKind,
            data?.aiConfigurationId,
            data?.aiConfigurationName,
            data?.aiExtractorId,
            data?.aiExtractorName,
            data?.aiExtractorType,
            data?.model,
            data?.openAiServiceTier,
            data?.requestCount ?? 0,
            data?.apiCallCount ?? 0,
            data?.webSearchCallCount ?? 0,
            data?.inputTokens ?? 0,
            data?.inputCachedTokens ?? 0,
            data?.outputTokens ?? 0,
            data?.totalTokens ?? 0,
            data?.executionTimeMs ?? 0,
            Number(data?.price ?? 0)
        );
    }
}

export default AiUsageBreakdownRow;
